export const BADGER_LIGHT_SUPERSET_THEME = {
  token: {
    colorPrimaryBg: '#d6e3ff',
    colorPrimaryBgHover: '#ecf0ff',
    colorPrimaryBorder: '#aac7ff',
    colorPrimaryBorderHover: '#7bacff',
    colorPrimaryHover: '#4090ff',
    colorPrimary: '#0a8dff',
    colorInfo: '#0a8dff',
    colorPrimaryActive: '#006cd9',
    colorPrimaryTextHover: '#4090ff',
    colorPrimaryText: '#0a8dff',
    colorPrimaryTextActive: '#006cd9',

    colorSuccessBg: '#e8f5ee',
    colorSuccessBgHover: '#dff0e7',
    colorSuccessBorder: '#9ed2b7',
    colorSuccessBorderHover: '#74bf9d',
    colorSuccessHover: '#63b58b',
    colorSuccess: '#4baa7a',
    colorSuccessActive: '#3c8d64',
    colorSuccessTextHover: '#63b58b',
    colorSuccessText: '#4baa7a',
    colorSuccessTextActive: '#3c8d64',

    colorWarningBg: '#f6f4db',
    colorWarningBgHover: '#f1edc5',
    colorWarningBorder: '#e3dc8a',
    colorWarningBorderHover: '#d6cc63',
    colorWarningHover: '#d6cc63',
    colorWarning: '#c9c556',
    colorWarningActive: '#a3951f',
    colorWarningTextHover: '#d6cc63',
    colorWarningText: '#c9c556',
    colorWarningTextActive: '#a3951f',

    colorErrorBg: '#fdd3d3',
    colorErrorBgHover: '#ffdede',
    colorErrorBorder: '#f29a9b',
    colorErrorBorderHover: '#e56f71',
    colorErrorHover: '#e56f71',
    colorError: '#de494b',
    colorErrorActive: '#b9363a',
    colorErrorTextHover: '#e56f71',
    colorErrorText: '#de494b',
    colorErrorTextActive: '#b9363a',

    colorTextSecondary: '#6b6b6b',
    colorTextTertiary: '#9b9b9b',
    colorTextQuaternary: '#bdbdbd',

    colorBorder: '#cbcbcb',
    colorBorderSecondary: '#9b9b9b',

    colorFill: '#ebebeb',
    colorFillSecondary: '#f2f2f2',
    colorFillTertiary: '#e2e2e2',
    colorFillQuaternary: '#dbdbdb',

    colorBgContainer: '#ffffff',
    colorBgElevated: '#f9f9f9',
    colorBgLayout: '#f2f2f2',
    colorBgSpotlight: 'rgba(34, 47, 62, 0.85)',

    borderRadiusSM: 6,
    borderRadius: 8,
    borderRadiusLG: 12
  },
  algorithm: ['default']
};
